import React from "react";
import styles from "./index.module.scss";
import calendarIcon from "../../assets/images/calenderSvg.svg";
import checkInIcon from "../../assets/images/timerSvg.svg";
import checkOutIcon from "../../assets/images/checkoutSvg.svg";
import investmentIcon from "../../assets/images/inverstmentSvg.svg";
import GrayLine from "../../common/components/GrayLine";

interface ProgramInfoCardProps {
  title: string;
  programDates: string;
  checkInTime: string;
  checkOutTime: string;
  investment: string;
}

const ProgramInfoCard: React.FC<ProgramInfoCardProps> = ({
  title,
  programDates,
  checkInTime,
  checkOutTime,
  investment,
}) => {
  return (
    <div className={styles.card_container}>
      {/* <h3 className={styles.card_title}>{title}</h3> */}
      <div className={styles.card_content}>
        <div className={styles.card_item}>
          <img src={calendarIcon} alt="Program Dates" />
          <div className={styles.text_content}>
            <p className={styles.label}>Program Dates</p>
            <p className={styles.value}>{programDates}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={checkInIcon} alt="Check-in Time" />
          <div className={styles.text_content}>
            <p className={styles.label}>Check-in Time</p>
            <p className={styles.value}>{checkInTime}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={checkOutIcon} alt="Check-out Time" />
          <div className={styles.text_content}>
            <p className={styles.label}>Check-out Time</p>
            <p className={styles.value}>{checkOutTime}</p>
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.card_item}>
          <img src={investmentIcon} alt="Investment" />
          <div className={styles.text_content}>
            <p className={styles.label}>Investment</p>
            <p className={styles.value}>{investment}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramInfoCard;
